module.exports = __webpack_public_path__ + "img/faster_option.svg";